import React, { useState } from 'react';
import { Add } from '@mui/icons-material';

import Button from '@/components/input/Button';
import Dialog from '@/components/dataDisplay/Dialog';
import theme from '@/constants/theme';
import { Route } from '@/services/routes/route.vm';
import { Stage } from '@/services/stages/stage.vm';

import CreateEditContentForm from '../CreateEditContentForm';

interface CreateContentProps {
  routeId?: Route['id'];
  stageId?: Stage['id'];
  isStageContent?: boolean;
}

const CreateContentButton: React.FC<CreateContentProps> = ({
  routeId,
  stageId,
  isStageContent = false,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  if (!routeId) return null;
  return (
    <>
      <Button Icon={Add} onClick={handleOpen}>
        Añadir Contenido
      </Button>
      <Dialog open={open} setOpen={setOpen} disabledBackdropClick>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            width: '640px',
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <h2>Añadir Contenido</h2>
            <p style={{ color: theme.colors.text.caption }}>
              Los contenidos añadidos se ligaran directamente esta {isStageContent ? 'etapa' : 'ruta'}.
            </p>
          </div>
          <CreateEditContentForm
            routeId={routeId}
            stageId={stageId}
            onSubmit={handleCancel}
            onCancel={handleCancel}
            isStageContent={isStageContent}
          />
        </div>
      </Dialog>
    </>
  );
};

export default CreateContentButton;
